import CommonAvatar from "@/components/Common/Avatar";
import DetailCardItem from "@/components/DetailCardItem";
import DetailCardItemWrapper from "@/components/DetailCardItemWrapper";
import { SCENARIO_DECISION_LABELS } from "@/consts/Scenario";
import { formatDate } from "@/libs/utils";
import { ReadScenarioApprovalsByIdResponse } from "@/types/scenario-approvals";

type Props = {
  data: ReadScenarioApprovalsByIdResponse;
};

export default function ApprovalDetailInfo({ data }: Props) {
  const infoItems = [
    { label: "승인 시나리오", value: data.title },
    { label: "소속 프로젝트", value: data.project_group_title || "-" },
    {
      label: "요청자",
      value: (
        <CommonAvatar
          img_url={data.requested_by.img_url}
          alt={data.requested_by.user_name}
          name={data.requested_by.user_name}
        />
      ),
    },
    {
      label: "요청 시점",
      value: formatDate(data.created_at),
    },
    {
      label: "승인 상태",
      value: SCENARIO_DECISION_LABELS[data.final_decision],
    },
  ];

  return (
    <div className="p-5">
      <DetailCardItemWrapper>
        {infoItems.map((item) => (
          <DetailCardItem key={item.label} {...item} />
        ))}
      </DetailCardItemWrapper>
    </div>
  );
}
